module.exports = __webpack_public_path__ + "img/BGMain3.097148b0.jpg";